import { PICKUP_WEB_SECTION_ID, CURATED_STAYS_WEB_SECTION_ID, EXPERIENCE_SECTION_DISPLAY_WEB_PAGE_PATHS } from '@/wabunka-src/constants/experienceSectionWebPagePath';
import { useGetExperienceSectionsQuery } from '@/wabunka-src/features/Experience';
import type { ExperienceSectionViewModel } from '@/wabunka-src/features/Experience';

export const useTopExperienceSections = async () => {
  const { experienceSections } = await useGetExperienceSectionsQuery(EXPERIENCE_SECTION_DISPLAY_WEB_PAGE_PATHS.TOP, []);

  const pickUpExperienceSection = computed(() => (experienceSections.value ?? []).find((section: ExperienceSectionViewModel) => section.webSectionId === PICKUP_WEB_SECTION_ID));
  // Curated_Stays は専用の Experiential Stays セクションで表示するため、
  // pick-up と同様に ExperiencesSection 向けの recommended からは除外して二重表示を防ぐ
  const recommendedExperienceSections = computed(() =>
    (experienceSections.value ?? []).filter((section: ExperienceSectionViewModel) => section.webSectionId !== PICKUP_WEB_SECTION_ID && section.webSectionId !== CURATED_STAYS_WEB_SECTION_ID),
  );

  // Curated_Stays セクションはこの全件レスポンスに含まれるため、ここから取り出して共有する
  // （Experiential Stays 側で /experienceSections を再取得しないことで二重 fetch を避ける）
  const curatedStaysSection = computed(() => (experienceSections.value ?? []).find((section: ExperienceSectionViewModel) => section.webSectionId === CURATED_STAYS_WEB_SECTION_ID));

  return { pickUpExperienceSection, recommendedExperienceSections, curatedStaysSection };
};
